module.exports = __webpack_public_path__ + "img/static-map@2x.e0cf1bcc.png";